import { filterPatientFilesByCategory } from '@/lib/patientFileCategories';

/** Fields a clinician can match when searching a patient's files. */
export type PatientFileSearchRow = {
  category_id: string | null;
  original_filename: string;
  filename?: string;
  document_title?: string | null;
  document_author?: string | null;
  notes?: string | null;
  document_date?: string | null;
  tags?: readonly string[] | null;
};

/**
 * Files the browse list shows. Category (fil-tag) and free text both apply.
 * An empty query keeps every file in the chosen category. Search matches the
 * file name, clinical title, author, notes, document date, tag names, and any
 * extra lines the caller adds (category name, source label).
 */
export function filterPatientFilesForBrowse<T extends PatientFileSearchRow>(
  files: readonly T[],
  input: {
    query: string;
    categoryId: string;
    extraText?: (file: T) => readonly string[];
  },
): T[] {
  const needle = input.query.trim().toLocaleLowerCase('da');
  const inCategory = filterPatientFilesByCategory(files, input.categoryId);
  if (!needle) return inCategory;
  return inCategory.filter((file) => {
    const hay = [
      file.original_filename,
      file.filename ?? '',
      file.document_title ?? '',
      file.document_author ?? '',
      file.notes ?? '',
      file.document_date ?? '',
      ...(file.tags ?? []),
      ...(input.extraText?.(file) ?? []),
    ]
      .join('\n')
      .toLocaleLowerCase('da');
    return hay.includes(needle);
  });
}
